import React from "react";
import "./Vision_and_Revolution.css";

/* ================= VISION ASSETS ================= */
import BrushVision from "../../../Assets/Home/Vision_Section/Brush.png";
import Food from "../../../Assets/Home/Vision_Section/prod.png";

/* ================= REVOLUTION ASSETS ================= */
import BgImage from "../../../Assets/Home/Revolution_Section/bg.jpg";
import BrushRevolution from "../../../Assets/Home/Revolution_Section/Brush.png";
import Icon from "../../../Assets/Icons/ai-star.png";

export default function Vision_and_Revolution({ onOpenComingSoon, onOpenInvestors }) {
    return (
        <div className="vision-and-revolution-container">
            {/* ================= VISION SECTION ================= */}
            <section className="vision-wrapper">
                <div className="vision-card">
                    <div className="vision-content">
                        {/* TITLE + BRUSH */}
                        <div className="vision-title-row">
                            <h2 className="vision-title">Our Vision</h2>
                            <div
                                className="vision-underline"
                                style={{ backgroundImage: `url(${BrushVision})` }}
                            ></div>
                        </div>

                        <p className="vision-text">
                            Providing services to more than <br />
                            <span className="highlight-red">1M stores</span>
                        </p>

                        <p className="vision-author">
                            — DoubleTap Innovations and Technologies Private Limited
                        </p>
                    </div>

                    {/* BACKGROUND CIRCLE + FOOD */}
                    <div className="vision-circle">
                        <img src={Food} alt="food" className="food-img" />
                    </div>
                </div>
            </section>

            {/* ================= REVOLUTION SECTION ================= */}
            <section
                className="revolution-wrapper"
                style={{ backgroundImage: `url(${BgImage})` }}
            >
                <div className="overlay-bg"></div>

                <div className="revolution-content">
                    <div className="revolution-pill">
                        <img src={Icon} alt="icon" />
                        Complete AI Ecosystem
                    </div>

                    <h2 className="revolution-title">Ready for AI Revolution?</h2>
                    <img
                        src={BrushRevolution}
                        alt="underline"
                        className="revolution-underline"
                    />

                    <p className="revolution-desc">
                        Join thousands of retailers already using Fulupo to revolutionize
                        their operations. Experience the power of Voice AI, Image Recognition,
                        and Smart Analytics today.
                    </p>

                    <div className="revolution-buttons">
                        <button className="btn-green" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.doubletap.fulupo", "_blank")}>
                            Consumers
                        </button>
                        <button className="btn-consumers" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.doubletap.fulupostore", "_blank")}>Store Owners</button>
                        <button className="btn-invest" onClick={onOpenInvestors}>
                            Investors
                        </button>
                        <button className="btn-delivery" onClick={() => window.open("https://play.google.com/store/apps/details?id=com.doubletap.fulupodelivery", "_blank")}>
                            Delivery Partners
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}
